import { get } from '../../../../DAL/data-provider';

/**
 * /api/sitesearch/support-search?query=cla
 */
export const getSearchData = async (query: string) => {
    return get('/api/sitesearch/support-search', {
        query: query.trim(),
    });
};